enum ActionType {
    REQUEST_ENGINE_STATUS = '[ENGINE STATUS] REQUEST DATA',
    RECEIVED_ENGINE_STATUS = '[ENGINE STATUS] RECEIVE DATA',
}

export default ActionType
